import { EVALUATION_STATUS } from "#customTypes/composedTypes/evaluationTypes"

export const DASHBOARD_EVALUATION_STATUSES = new Set<EVALUATION_STATUS>([
  EVALUATION_STATUS.NOT_STARTED,
  EVALUATION_STATUS.IN_PROGRESS,
  EVALUATION_STATUS.SUBMITTED,
  EVALUATION_STATUS.APPROVED,
  EVALUATION_STATUS.REJECTED,
  EVALUATION_STATUS.PRINTED,
])
